(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();

      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('ul'),
      };

      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);

      if (this.classList.contains('on-header')) {
        document.body.classList.remove('localization--open');
      }
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      // this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      // this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());

      if (this.classList.contains('on-header')) {
        document.body.classList.toggle('localization--open');
      }
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }
  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 100);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["headerV2"] && !Shopify.designMode) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.getElementById('shopify-section-headerV2');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.connectedCallback();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          } else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        } else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      } else {
        if (this.header.classList.contains('shopify-section-header-sticky')) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    reveal() {
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["layered-content-builder"] && !Shopify.designMode) return;
  try {
    
    class LayeredContentBuilder {
      constructor(container) {
        this.container = container;
        this.layers = container.querySelectorAll('.layer-item');
        this.init();
      }

      init() {
        this.addDragResizeHandles();
        this.setupResponsiveBehavior();
        this.addKeyboardAccessibility();
        this.adjustContainerHeight(); // NEW: Auto-adjust height
      }

// NEW: Dynamically adjust container height to contain all layers
      adjustContainerHeight() {
        if (!this.container) return;
        

        let minTop = Infinity;
        let maxBottom = -Infinity;
        const containerRect = this.container.getBoundingClientRect();
        const containerTop = containerRect.top;

        this.layers.forEach(layer => {
          const layerRect = layer.getBoundingClientRect();
          const layerTop = layerRect.top - containerTop;
          const layerBottom = layerRect.bottom - containerTop;

          minTop = Math.min(minTop, layerTop);
          maxBottom = Math.max(maxBottom, layerBottom);
        });

// If we have valid measurements, adjust the container height
        if (minTop !== Infinity && maxBottom !== -Infinity) {
          const totalHeight = maxBottom - Math.min(0, minTop);
          const currentHeight = parseInt(this.container.style.minHeight);

// Add padding to prevent elements from touching edges
          const paddedHeight = totalHeight + 50;

// Only update if needed (avoid infinite loops)
          if (Math.abs(currentHeight - paddedHeight) > 10) {
            this.container.style.minHeight = `${paddedHeight}px`;
          }
        }
      }

      addDragResizeHandles() {
        this.layers.forEach(layer => {
          let isDragging = false;
          let startX,
            startY,
            startLeft,
            startTop,
            usePixels = false;
          const topStyle = layer.style.top;
          usePixels = topStyle && topStyle.includes('px');

          layer.addEventListener('mousedown', (e) => {
            if (e.target === layer || layer.contains(e.target)) {
              isDragging = true;
              startX = e.clientX;
              startY = e.clientY;
              const left = parseFloat(layer.style.left);
              const top = parseFloat(layer.style.top);
              startLeft = isNaN(left)
                ? (
                  usePixels
                    ? 0
                    : 50
                )
                : left;
              startTop = isNaN(top)
                ? (
                  usePixels
                    ? 0
                    : 50
                )
                : top;
              e.preventDefault();
            }
          });

          window.addEventListener('mousemove', (e) => {
            if (! isDragging) return;
            

            const deltaX = e.clientX - startX;
            const deltaY = e.clientY - startY;

            if (usePixels) {
              let newLeft = startLeft + deltaX;
              let newTop = startTop + deltaY;
              layer.style.left = `${newLeft}px`;
              layer.style.top = `${newTop}px`;
            } else {
              const containerRect = this.container.getBoundingClientRect();
              let newLeft = startLeft + (deltaX / containerRect.width) * 100;
              let newTop = startTop + (deltaY / containerRect.height) * 100;
              newLeft = Math.max(-50, Math.min(150, newLeft));
              newTop = Math.max(-50, Math.min(150, newTop));
              layer.style.left = `${newLeft}%`;
              layer.style.top = `${newTop}%`;
            }

// Update container height after repositioning
            this.adjustContainerHeight();
          });

          window.addEventListener('mouseup', () => {
            isDragging = false;

// Final height adjustment
            this.adjustContainerHeight();
          });
        });
      }

      setupResponsiveBehavior() {
        const handleResize = () => {
          if (window.innerWidth<= 768) {
          this.layers.forEach(layer => {
            if (layer.classList.contains('layer-text')) {
              const fontSize = parseFloat(layer.style.fontSize);
              if (fontSize) {
                layer.style.setProperty('--original-font-size', fontSize);
                layer.style.fontSize = `${
                  fontSize * 0.7
                }px`;
              }
            }
          }) 
          
        } else {
          this.layers.forEach(layer => {
            if (layer.classList.contains('layer-text')) {
              const originalSize = layer.style.getPropertyValue('--original-font-size');
              if (originalSize) {
                layer.style.fontSize = originalSize;
              }
            }
          });
        }

// Recalculate height on resize
        setTimeout(() => this.adjustContainerHeight(), 100);
      };

      window.addEventListener('resize', handleResize);
      handleResize();
    }

    addKeyboardAccessibility() {
      this.layers.forEach(layer => {
        layer.setAttribute('tabindex', '0');
        layer.addEventListener('keypress', (e) => {
          if (e.key === 'Enter' || e.key === ' ') {
            const link = layer.querySelector('a');
            if (link) {
              link.click();
            }
          }
        });
      });
    }
  }

  document.addEventListener('DOMContentLoaded', () => {
    const containers = document.querySelectorAll('[data-section-type="layered-content"]');
    containers.forEach(container => {
      new LayeredContentBuilder(container);
    });
  });
  
  } catch(e) { console.error(e); }
})();
})();
